<template>
  <ul class="headerNavigation" v-if="actions.length > 0">
    <li class="item" v-for="(item, index) in actions" v-bind:key="index">
      <router-link
        v-bind:class="['items-navig', item.isActive() ? 'active-item' : '']"
        v-bind:to="item.href"
      >{{ item.label }}</router-link>
    </li>
  </ul>
</template>

<script>
import NavigationItem from '@/lib/transfer-objects/NavigationItem.js'

export default {
  name: 'Navigation',
  props: {
    actions: {
      type: Array,
      required: true,
      validator: function (value) {
        value.forEach(item => {
          if (!(item instanceof NavigationItem)) {
            throw new Error('Action list must be an array of NavigationItem objects.')
          }
        })
        return true
      }
    }
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'

.headerNavigation
  padding: 0

  .item
    display: inline-block
    margin-right: 10px


  .items-navig
    color: $black
    text-decoration: none
    text-transform: uppercase
    font-weight: bold
    font-size: 0.6875rem
    padding: 8px 20px 9px 20px
    text-align: center
    transition: background-color, color

    &:hover
      border-radius: 16px
      background-color: $blue-active
      color: $white
      transition-duration: 0.5s, 0.2s

  .active-item
    border-radius: 16px
    background-color: $blue-active
    color: $white

</style>



// WEBPACK FOOTER //
// src/components/generics/Navigation.vue